module.exports = __webpack_public_path__ + "img/sm.2f847792.jpg";